var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#D2D3D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_15101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 76.25C64.4975 76.25 76.25 64.4975 76.25 50C76.25 35.5025 64.4975 23.75 50 23.75C35.5025 23.75 23.75 35.5025 23.75 50C23.75 64.4975 35.5025 76.25 50 76.25Z",
    stroke: "#222529",
    strokeWidth: 5.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25 41.25H41.2792",
    stroke: "#222529",
    strokeWidth: 5.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.75 41.25H58.7792",
    stroke: "#222529",
    strokeWidth: 5.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0003 64.5833C53.222 64.5833 55.8337 61.9717 55.8337 58.75C55.8337 55.5283 53.222 52.9167 50.0003 52.9167C46.7787 52.9167 44.167 55.5283 44.167 58.75C44.167 61.9717 46.7787 64.5833 50.0003 64.5833Z",
    stroke: "#222529",
    strokeWidth: 5.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_15101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.a7080b622dceeac1d1b8a48250c2cdf7.svg";
export { ForwardRef as ReactComponent };